import React from 'react';

import { DefaultComponentProps } from '../../../types';

import { CardBody, CardHeader } from '../../../components';

interface Props extends DefaultComponentProps {
  tryToSubmitAgain?: () => void;
}

export const PinSent = ({ textConfig, tryToSubmitAgain }: Props) => {
  const { title, ingress, emoji, emojiLabel, createUserButton } = textConfig.pinSent;

  return (
    <>
      <CardHeader title={title} ingress={ingress} emoji={emoji} emojiLabel={emojiLabel} />
      <CardBody>
        <button id="wp-" onClick={tryToSubmitAgain} className="form__field__submit__button">{createUserButton}</button>
      </CardBody>
    </>
  );
};
